/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AllShipmentsMapPoint
 */
export interface AllShipmentsMapPoint {
  /**
   *
   * @type {string}
   * @memberof AllShipmentsMapPoint
   */
  shipmentId: string;
  /**
   *
   * @type {boolean}
   * @memberof AllShipmentsMapPoint
   */
  booked: boolean;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsMapPoint
   */
  pickupLat: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsMapPoint
   */
  pickupLng: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsMapPoint
   */
  deliveryLat: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsMapPoint
   */
  deliveryLng: number;
}

/**
 * Check if a given object implements the AllShipmentsMapPoint interface.
 */
export function instanceOfAllShipmentsMapPoint(
  value: object,
): value is AllShipmentsMapPoint {
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  if (!("booked" in value) || value["booked"] === undefined) return false;
  if (!("pickupLat" in value) || value["pickupLat"] === undefined) return false;
  if (!("pickupLng" in value) || value["pickupLng"] === undefined) return false;
  if (!("deliveryLat" in value) || value["deliveryLat"] === undefined)
    return false;
  if (!("deliveryLng" in value) || value["deliveryLng"] === undefined)
    return false;
  return true;
}

export function AllShipmentsMapPointFromJSON(json: any): AllShipmentsMapPoint {
  return AllShipmentsMapPointFromJSONTyped(json, false);
}

export function AllShipmentsMapPointFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AllShipmentsMapPoint {
  if (json == null) {
    return json;
  }
  return {
    shipmentId: json["shipmentId"],
    booked: json["booked"],
    pickupLat: json["pickupLat"],
    pickupLng: json["pickupLng"],
    deliveryLat: json["deliveryLat"],
    deliveryLng: json["deliveryLng"],
  };
}

export function AllShipmentsMapPointToJSON(json: any): AllShipmentsMapPoint {
  return AllShipmentsMapPointToJSONTyped(json, false);
}

export function AllShipmentsMapPointToJSONTyped(
  value?: AllShipmentsMapPoint | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentId: value["shipmentId"],
    booked: value["booked"],
    pickupLat: value["pickupLat"],
    pickupLng: value["pickupLng"],
    deliveryLat: value["deliveryLat"],
    deliveryLng: value["deliveryLng"],
  };
}
